import { Helmet } from 'react-helmet';
import KhoDetail
  from 'src/components/kho-detail/KhoDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import KhoListToolbar from '../components/kho-detail/KhoToolbar';

const Kho = () => (
  <>
    <Helmet>
      <title>Quản lý kho</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <KhoListToolbar />
        <Box sx={{ pt: 3 }}>
          <KhoDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Kho;
